var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overview-tab"},[_c('information-block',{ref:"infoBlock"}),_c('top-present-table',{ref:"topPresentTable",attrs:{"defaultTerms":_vm.filteringOptions.defaultTerms,"defaultClasses":_vm.filteringOptions.defaultClasses}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }